import { render, staticRenderFns } from "./user_agents_platform_index.vue?vue&type=template&id=5a92c7e0"
import script from "./user_agents_platform_index.vue?vue&type=script&lang=js"
export * from "./user_agents_platform_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports